const CV_URL = 'https://theo-portfolio-docs.s3.eu-west-2.amazonaws.com/Theo_Matthews_CV--Public.pdf';
export default CV_URL;